export default __webpack_public_path__ + "static/media/chapter-banner.edf9efce.jpg";